import { Request } from '@/services/api';

export class MessagesManagementService {
  static queueStats() {
    return Request().get(`/admin/messages-management/queues/stats`);
  }

  static jobs(query: string) {
    return Request().get(`/admin/messages-management/queues/jobs${query || ''}`);
  }

  static retryJob(jobId: string | number) {
    return Request().post(`/admin/messages-management/queues/jobs/${jobId}/retry`, {});
  }

  static removeJob(jobId: string | number) {
    return Request().delete(`/admin/messages-management/queues/jobs/${jobId}`);
  }

  static batches(query: string) {
    return Request().get(`/admin/messages-management/batches${query || ''}`);
  }

  static batchChunks(batchId: number, query: string) {
    return Request().get(`/admin/messages-management/batches/${batchId}/chunks${query || ''}`);
  }

  static resolveChunk(chunkId: number, action: 'refund' | 'mark-sent') {
    return Request().post(`/admin/messages-management/chunks/${chunkId}/resolve`, {
      action,
    });
  }

  static logs(query: string) {
    return Request().get(`/admin/messages-management/logs${query || ''}`);
  }

  static logsFilters() {
    return Request().get(`/admin/messages-management/logs/filters`);
  }

  static exportLogs(query: string) {
    return Request().get(`/admin/messages-management/logs/export${query || ''}`, {
      responseType: 'blob',
      // Export pages through the reporting API server-side; large date ranges
      // legitimately take longer than the default 80s client timeout.
      timeout: 300000,
    });
  }
}
